import LeadTimeRequests from '../../server/leadTime';
import { addLoading, removeLoading } from './loading';

export const setLeadTime = leadTime => ({
  type: 'GET_LEAD_TIME',
  leadTime,
});

export const setLeadTimes = leadTimes => ({
  type: 'GET_LEAD_TIMES',
  leadTimes,
});

const createLeadTime = leadTime => async (dispatch) => {
  dispatch(addLoading());
  try {
    await LeadTimeRequests.createLeadTime(leadTime);
  } finally {
    dispatch(removeLoading());
  }
};

const updateLeadTime = leadTime => async (dispatch) => {
  dispatch(addLoading());
  try {
    await LeadTimeRequests.updateLeadTime(leadTime);
  } finally {
    dispatch(removeLoading());
  }
};

const getLeadTime = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const leadTime = await LeadTimeRequests.getLeadTime(id);
    dispatch(setLeadTime(leadTime));
  } finally {
    dispatch(removeLoading());
  }
};

const getLeadTimes = (limit, skip, search, force = false, order = '', field = '') => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const leadTimes = await LeadTimeRequests.getLeadTimes(limit, skip, search, order, field);
    dispatch(setLeadTimes(leadTimes));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

export const getLeadTimesSelect = (search, force = false) => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const leadTimes = await LeadTimeRequests.getLeadTimes(1000, 0, search, 'ASC', 'id');
    dispatch(setLeadTimes(leadTimes));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

const deleteLeadTime = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await LeadTimeRequests.deleteLeadTime(id);
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createLeadTime,
  getLeadTime,
  getLeadTimes,
  updateLeadTime,
  deleteLeadTime,
  getLeadTimesSelect,
};
